import { COLORS } from "../../../styles/uiConstants";

/**
 * Token grafiklerinin ORTAK renk sözlüğü.
 *
 * Kural: token ekranındaki her renk TEK bir işi yapar — hareketin YÖNÜNÜ
 * gösterir. Altı ayrı hareket tipine altı ayrı renk vermek (eski tasarım)
 * okuyucuya "bu renk ne demek?" sorusunu her seferinde yeniden sordurttuğu için
 * bırakıldı. Yön = ıraksayan (diverging) çift: mavi giriş, kırmızı çıkış,
 * nötr gri sıfır/etkisiz.
 *
 * Çift, CVD (renk körlüğü) doğrulayıcısından geçti — beyaz zeminde
 * protanopi ΔE 21.6, normal görüş ΔE 32.3, kontrast ≥ 3:1.
 *
 * Klinik tema rengi (palette.primary) BİLEREK kullanılmaz: kliniğe göre
 * değiştiği için "mavi = giriş" anlamı kliniğe göre kayardı.
 */
export const FLOW_COLORS = {
  in: "#2a78d6", // yükleme / giriş
  out: "#e34948", // tüketim / iade / çıkış
  neutral: COLORS.slate400, // düzeltme, sıfır ekseni
};

/** Sunucudan gelen işaretli toplam pozitifse giriş, negatifse çıkış. */
export const flowColorOf = (signedTotal) => {
  if (signedTotal > 0) return FLOW_COLORS.in;
  if (signedTotal < 0) return FLOW_COLORS.out;
  return FLOW_COLORS.neutral;
};

/** "2026-08" → "Ağu 2026" */
const TR_MONTHS = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];
export function formatMonthTR(key) {
  const [y, m] = String(key || "").split("-");
  const idx = Number(m) - 1;
  if (!y || Number.isNaN(idx) || !TR_MONTHS[idx]) return key;
  return `${TR_MONTHS[idx]} ${y}`;
}

export const formatToken = (n) => Number(n || 0).toLocaleString("tr-TR");
